import styled from 'styled-components';
import { Grid as GridAtom } from 'components/atoms/grid';
import { DullCaption } from '../component';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-05);
  > svg {
    width: var(--layout-03);
    height: var(--layout-03);
  }
`;

export const EventWrapper = styled.div`
  height: 100%;
  width: 100%;
`;

export const GridContainer = styled.div`
  .ag-selection-checkbox {
    opacity: 1;
  }
  .ag-horizontal-left-spacer {
    display: none;
  }
  .ag-row-odd {
    background-color: var(--ag-background-color, var(--white-100));
  }
  .ag-react-container article {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 240px;
  }
  .ag-row-selected {
    background-color: initial;
    background: initial;
  }
  .ag-row-focus.ag-row-selected {
    background-color: initial;
    background: initial;
  }
  .ag-row-selected .ag-cell-focus {
    background-color: initial;
    background: initial;
  }
`;

export const Grid = styled(GridAtom)`
  .ag-root-wrapper {
    overflow: visible;
  }
  .dull {
    color: var(--gray-60);
  }
  .ag-react-container > :not(:first-child) {
    display: none !important;
  }
  .ag-row-hover {
    background-color: initial;
    background: initial;
  }
`;

export const NoMoreEvent = styled(DullCaption)`
  padding: var(--spacing-10) 0 var(--spacing-10);
  text-align: center;
`;
